import React from "react";
import styles from "./EmptyLayer.module.css";

const EmptyLayer = () => (
  <div key="no-elements" className={styles.root}>
    - empty -
  </div>
);

export default EmptyLayer;
